<template>
    <div class="p-5">
      <div
        class="flex items-center justify-between w-full h-1/6"
        style="height: fit-content"
      >
        <h1 class="text-2xl font-medium">Customers</h1>
      </div>
      <div class="w-full">

      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
  },
  data(){
    return{
          };
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
  },
  methods: {
  },
  beforeCreate() {
    this.$store.dispatch("user/getUser");
  },
};
</script>

<style lang="css" scoped></style>